var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-title"},[_vm._t("header")],2)]),_c('div',{staticClass:"main"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }